<template>
  <div class="main-width">
    <div class="interpretation home-interpretation">
      <div style="margin-bottom: 10px">

        <p style="margin-bottom: 10px">
          ClinSR.org is a multifunctional platform that enables the dynamic illustration of how ClinSR changes over
          time, the automated update of ClinSRs for the coming decade, and the customized evaluation of the ClinSR for
          any drug group of interest. </p>

        This website describes the change of
        <span style="font-style: italic">clinical trial success rates</span>
        (ClinSR) of drugs over time. Readers can select a
        <span style="font-style: italic; font-weight: bold" class="orange-link" @click="optionsByDiseaseClass()">Disease
          Class</span>
        or a
        <span style="font-style: italic; font-weight: bold" class="orange-link" @click="optionsByDrugModality()">Drug
          Modality</span>
        to visualize the corresponding ClinSR since year 2000. Various databases
        (<span style="font-style: italic" class="blue-link" @click="dialogTip = true">show details</span>) were included
        to in the analysis, and this website will be
        continuously updated to illustrate the temporal ClinSR for all drugs of
        the 21st century.
      </div>
      <div class="to-select">
        <div>Click to Select</div>
        <i class="fa fa-angle-double-right" aria-hidden="true" style="margin: 0 15px"></i>
      </div>

      <div style="display: flex; margin-top: -20px">
        <div class="new-font new-font-select" style="font-weight: bold; display: flex; margin: 0 auto"
          @click="optionsByDiseaseDrug()">
          <div style="white-space: nowrap">
            {{ dis_value_show }}
          </div>

          <div>
            <i class="fa fa-angle-down" aria-hidden="true" style="margin: 0 5px"></i>
          </div>
        </div>
      </div>

      <el-dialog :title="dis_options_title" :visible.sync="dialogSelect" class="dialog-select">
        <el-cascader-panel v-model="dis_value" :options="dis_options_use" style="font-size: 20px; height: 100%"
          popper-class="train-tree-cascader"></el-cascader-panel>
      </el-dialog>

      <el-dialog title="Databases Included in The Analysis" :visible.sync="dialogTip">
        <div style="font-size: 20px; border: 1px solid #e4e7ed; padding: 16px">
          Drug approval data are gathered from the
          <a href="https://www.fda.gov/drugs" target="_blank" class="blue-link">U.S. FDA</a>
          (<a href="https://www.fda.gov/drugs" target="_blank"
            class="darkblue-link">https://www.fda.gov/drugs</a>)<br />
          Clinical trial information of drugs is collected from the
          <a href="https://clinicaltrials.gov" target="_blank" class="blue-link">ClinicalTrials.gov</a>
          (<a href="https://clinicaltrials.gov" target="_blank"
            class="darkblue-link">https://clinicaltrials.gov</a>)<br />
          Drug data are collected from
          <a href="https://go.drugbank.com/" target="_blank" class="blue-link">DrugBank</a>
          (<a href="https://scholar.google.com/scholar?cluster=444449718634568081" target="_blank"
            class="darkblue-link"><i>Nucleic Acids Res</i>. 2018</a>) and
          <a href="https://db.idrblab.net/ttd/" target="_blank" class="blue-link">TTD</a>
          (<a href="https://scholar.google.com/scholar?cluster=2447918495040264217" target="_blank"
            class="darkblue-link"><i>Nucleic Acids Res</i>. 2020</a>)<br />
          Disease classification is standardized based on the
          <a href="https://icd.who.int/" target="_blank" class="blue-link">WHO ICD-11</a>
          (<a href="https://doi.org/10.1016/S0140-6736(19)31205-X" target="_blank" class="darkblue-link"><i>Lancet</i>,
            2019</a>)
        </div>
      </el-dialog>
    </div>

    <SuccessRateHome :dis_value_show="dis_value_show" calMethod="CDPs" :dis_value="dis_value_selected">
    </SuccessRateHome>
    <SuccessRateHome :dis_value_show="dis_value_show" calMethod="MEs" :dis_value="dis_value_selected"></SuccessRateHome>
    <!-- <SuccessRateHome
      :dis_value_show="dis_value_show"
      :dis_value="dis_value_selected"
    ></SuccessRateHome> -->

    <DrugType :dis_value_show="dis_value_show" :dis_value="dis_value_selected" v-show="displayDrugTypeData"></DrugType>
    <!-- <SuccessRateDisease :dis_value="dis_value_selected"></SuccessRateDisease> -->
    <!-- <div-unit unitTitle="Statistics for" :customHTML="dis_value_show">
      <div class="plot-row">
        <div id="statistics1" class="small-plot">
          <StatisticsPlot12
            statistics="statistics1"
            title="Cumulative number of trials over time"
            :dis_value="dis_value_selected"
          ></StatisticsPlot12>
        </div>
        <div id="statistics2" class="small-plot">
          <StatisticsPlot12
            statistics="statistics2"
            title="Cumulative number of trials for each time window"
            :dis_value="dis_value_selected"
          ></StatisticsPlot12>
        </div>
      </div>

      <div
        class="plot-row"
        style="box-shadow: 1px 1px 4px 5px #e4e8f5; border-radius: 6px"
      >
        <div
          id="statistics3"
          class="small-plot"
          style="height: 568px; box-shadow: 0 0 0px 0px #e4e8f5"
        >
          <StatisticsPlot3 :dis_value="dis_value_selected"></StatisticsPlot3>
        </div>
        <div
          id="statistics4"
          class="small-plot"
          style="height: 568px; box-shadow: 0 0 0px 0px #e4e8f5"
        >
          <StatisticsPlot4 :dis_value="dis_value_selected"></StatisticsPlot4>
        </div>
      </div>
    </div-unit> -->
  </div>
</template>

<script>
import "@/assets/fonts/font.css";
// import DivUnit from "@/components/DivUnit.vue";
import SuccessRateHome from "@/components/home/SuccessRateHome.vue";
// import SuccessRateDisease from "@/components/home/SuccessRateDisease.vue";
// import StatisticsPlot12 from "@/components/home/StatisticsPlot12.vue";
// import StatisticsPlot3 from "@/components/home/StatisticsPlot3.vue";
// import StatisticsPlot4 from "@/components/home/StatisticsPlot4.vue";
import DrugType from "@/components/home/DrugType.vue";
import api from "@/api/index";
// import pathUrl from "../../api/path";
export default {
  name: "HomeView",
  data() {
    return {
      calMethod: "CDPs",

      dialogSelect: false,
      dialogTip: false,
      dis_options: [],
      dis_options_use: [],
      dis_options_title: "",
      dis_value: ["Disease Class", "All diseases"],

      // plotPhaseDurationData: "",
      checkPhaseDurationData: true,

      plotDrugStatistics3Data: "",
      plotDrugStatistics4Data: "",

      plotDrugTypeData: "",
      checkDrugTypeData: true,

      displayDrugTypeData: true,
    };
  },
  components: {
    // DivUnit,
    SuccessRateHome,
    // SuccessRateDisease,
    // StatisticsPlot12,
    // StatisticsPlot3,
    // StatisticsPlot4,
    DrugType,
  },
  computed: {
    dis_value_selected() {
      return this.dis_value[1].replace("All drug modality", "All diseases");
    },
    dis_value_show() {
      // Add defensive checks first
      if (!Array.isArray(this.dis_value) || this.dis_value.length < 2) {
        return ""; // or some default value
      }

      const [category, value] = this.dis_value;

      // Handle "Disease Class" cases
      if (category === "Disease Class") {
        if (value === "Others [ICD11:M|N|A|J|K|L]") {
          return "Other disease classes";
        }
        // Extract text before '[' for other disease classes
        return value.split("[")[0].trim();
      }
      return value
    },
  },
  watch: {
    dis_value: {
      handler: function (o) {
        this.dialogSelect = false;
        this.displayDrugTypeData = o[0] == "Disease Class" ? true : false;

      },
      deep: true,
    },
  },
  methods: {
    optionsByDiseaseDrug() {
      this.dis_options_title = "Select a Disease Class or Drug Modality";
      this.dis_options_use = this.dis_options;
      this.dialogSelect = true;
    },
    optionsByDiseaseClass() {
      this.dis_options_title = "Select a Disease Class";
      this.dis_options_use = [this.dis_options[0]];
      this.dialogSelect = true;
    },
    optionsByDrugModality() {
      this.dis_options_title = "Select a Drug Modality";
      this.dis_options_use = [this.dis_options[1]];
      this.dialogSelect = true;
    },


  },
  beforeMount() {
    api.getDiseaseDrugtypeClass().then((res) => {
      this.dis_options = res.data.result;
    });
  },

};
</script>
<style lang="less" scoped>
@select-disease-color: #f1f1f1;

/deep/.div-unit-custom {
  color: #ee7700;
}

.new-font {
  font-family: Eras Demi ITC;
  font-size: 40px;
  color: #ee7700;
  font-weight: bold;
}

.new-font-select:hover {
  cursor: pointer;
  text-decoration: underline;
}

.to-select {
  // color: #cccccc00 !important;
  flex-grow: 1;
  display: flex;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  align-items: center;
}

/deep/ .el-dialog {
  width: 1000px;
  // height: 600px;
}

/deep/.el-dialog__header {
  padding: 20px;
  background: #455da5;
}

/deep/.dialog-select .el-dialog__header {
  background: #ee7700;
}

/deep/.el-dialog__body {
  color: #2c3e50;
}

/deep/.el-cascader-panel {
  height: 525px !important;
}

/deep/.el-dialog__title {
  font-size: 22px;
  font-weight: bold;
  color: #fff;
}

/deep/.el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}

/deep/.el-dialog__headerbtn:focus .el-dialog__close,
/deep/.el-dialog__headerbtn:hover .el-dialog__close {
  color: #fff;
}

/deep/.el-scrollbar__wrap {
  overflow: hidden;
  height: 100% !important;
}

/deep/.el-cascader-menu {
  padding-right: 30px;
}

/deep/.train-tree-cascader {
  height: 500px !important;
}

.train-tree-cascader .el-cascader-panel {
  height: 100% !important;
}

.train-tree-cascader .el-cascader-panel .el-cascader-menu__wrap {
  height: 104% !important;
}

/deep/ .el-select:hover {
  .el-input__inner {
    border-color: @select-disease-color;
  }
}

/deep/ .el-select__caret {
  color: #ee7700 !important;
  font-weight: bold !important;
  font-size: 40px !important;
}

/deep/.el-input--suffix {
  .el-input__inner {
    font-family: "ZabriskieInternational Light Regular";
    text-align: center;
    font-size: 40px !important;
    margin: -8px 0 -31px 0;
    color: #ee7700;
    font-weight: bold;
    background: @select-disease-color;
    border: 1px solid @select-disease-color;
    height: 60px;
  }
}

/deep/ .el-select {
  width: 100%;
  margin-top: 10px;

  .el-input__inner:focus {
    border-color: @select-disease-color;
  }

  .el-input.is-focus {
    .el-input__inner {
      border-color: @select-disease-color;
    }
  }
}

.home-interpretation {
  // display: flex;
  // flex-direction: column;
  // margin-top: 30px;
  // box-shadow: 4px 4px 4px 5px #e4e8f5;
  box-shadow: 0 0 2px 0 #7e7c7c;
  border-radius: 5px;
  margin-top: 30px;
  padding: 15px 25px;
  line-height: 1.5;
  background-color: #fafafa;
  text-align: justify;
}

.introduce-text {
  padding: 16px;
  background: #c55a111f;
  border-radius: 10px;
  font-size: 20px;
  box-shadow: 7px 6px 11px 0px #cbcaca;
  line-height: 1.8;
}

.plot-block-title {
  /* margin-top: 20px; */
  border: 3px solid #e5e9f5;
  border-bottom: 0;
  color: #6863e5;
  padding: 9px;
  font-weight: bold;
  background: #e5e9f524;
  display: flex;
  justify-content: space-between;
}

.div-tool {
  float: right;
  display: inline-block;
  margin-right: 5px;
}

.plot-block {
  /* box-shadow: 1px 3px 8px 4px #c4cce3; */
  /* height: 164px; */
  border: 3px solid #e5e9f5;
  margin: 0px 0 20px 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background: #e5e9f524;
}

.plot-block-icon {
  border-right: 3px solid #e5e9f5;
  width: 17%;
  display: flex;
  font-size: 24px;
  cursor: pointer;
  flex-direction: row;
  justify-content: space-around;
  color: #ffffff;
  font-weight: bold;
  margin: auto 0;
}

.plot-block-body {
  width: 80%;
  margin: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.plot-block-body-row {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin: 10px 0;
}

.plot-block-wordcloud {
  margin: auto 0;
  width: 20%;
  display: flex;
  font-size: 24px;
  cursor: pointer;
  flex-direction: row;

  border-radius: 30px;
  color: #ffffff;
  font-weight: bold;

  padding: 10px 0;
}

.plot-block-body-row>span {
  margin: auto 0;
  width: 20%;
  display: flex;
  justify-content: space-around;
  border-radius: 30px;
  background: #6e7dd3;
}

.plot-block-body-row>span:hover,
.plot-block-body-row>span:focus {
  text-decoration: none;
  color: #fbfbfb;
  background: #314ad7;
  box-shadow: 0 0 4px 6px #6a88e991;
  text-decoration: none;
}

.plot-block-wordcloud {
  text-decoration: none !important;
}

.plot-block-sunburst {
  text-align: center;
  margin: auto 0;
  width: 20%;
  display: flex;
  font-size: 24px;
  cursor: pointer;
  flex-direction: column;
  justify-content: space-around;
  border-radius: 30px;
  color: #ffffff;
  font-weight: bold;
  background: #fd9d75;
  padding: 10px 0;
}

.plot-block-sunburst:hover,
.plot-block-sunburst:focus {
  text-decoration: none;
  color: #fbfbfb;
  background: #ef5617;
  box-shadow: 0 0 4px 6px #fc84528f;
  text-decoration: none;
}

.tip-title {
  font-size: 20px;
  font-weight: bold;
}

.tip-content {
  font-size: 20px;
}



.half-big-plot {
  height: 450px;
  width: 100%;
  padding-top: 10px;
  box-shadow: 1px 1px 4px 5px #e4e8f5;
  border-radius: 6px;
}

.home-title {
  display: flex;
  text-align: center;
  height: 100px;
  background: #f2f2f2;
  margin-bottom: 15px;
}



.small-plot {
  height: 350px;
  width: 49%;
  margin-bottom: 10px;
  box-shadow: 1px 1px 4px 5px #e4e8f5;
  border-radius: 6px;
  padding-top: 10px;
}
</style>
